import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { TooltipsState } from './reducer';

const makeSelectActiveTooltip = createSelector(
  ({ tooltips }) => tooltips,
  ({ activeTooltip }: TooltipsState) => activeTooltip,
);

export const useActiveTooltipFromRedux = () => useSelector(makeSelectActiveTooltip);
